import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import CTA from '../../cta';

const Socials = ({ data, className }) => {
	if (!data?.[0]) return null;

	return (
		<List
			bullets='none'
			layout='inline'
			className={`socialNav justify-between md:justify-start ${className || ''}`}
		>
			{data.map((social, index) => (
				<li
					key={index}
					className={`socialNav-li-${index} leading-none md:mx-2`}
				>
					<CTA
						data={social}
						className={`socialNav-cta-${index} text-2xl text-neutral-400 hover:text-white [&_svg]:h-5`}
					>
						<span className='sr-only'>{social.link.title}</span>
					</CTA>
				</li>
			))}
		</List>
	);
};

Socials.propTypes = {
	data: PropTypes.array.isRequired,
	className: PropTypes.string,
};

export default Socials;
